import { Flex, Span, styled } from '@fareye/ui'
import { FaCheck, startCase } from '@fareye/utils'
import React, { useState } from 'react'


const DropdownContainer = styled(Flex)`
  flex-direction: column;
  cursor: pointer;
  padding: 12px;
  gap: 4px;
  background: #FFFF;
`
const DropdownItemWrapper = styled(Flex)`
  align-items: centre;
  justify-content: space-between;
  width: Fixed (112px)px;
  padding: 8px 4px;
  gap: 10px;
  border-radius: 8px;
  background: ${(props: any) => props.isSelected && "#FFF3F1"};
`

const DropdownItem = (props: any) => {
  const {label, value, filterValue, setFilterValue } = props
  const [isSelected, setIsSelected] = useState(Array.isArray(filterValue) ? filterValue.includes(value) : false)
  const handleClick = (value: string) => {
    if(!!isSelected) {
      // remove value from filterValue
      setFilterValue((prevState:any) => prevState.filter((el: string) => el !== value))
    } else {
      // add value to filterValue
      Array.isArray(filterValue) ? setFilterValue((prevState:any) => [...prevState, value]): setFilterValue([value])
    }
    setIsSelected((prevState: boolean) => !prevState)
  }

  return (
    <DropdownItemWrapper isSelected={isSelected} onClick={() => {handleClick(value)}}>
      <Span style ={{fontSize: '14px', fontWeight: 400, color: '#202C39', fontFamily: 'lato'}}>
        {startCase(label)}
      </Span>
      {isSelected && <FaCheck style = {{'height': '14px', 'width': '14px'}}/>}
    </DropdownItemWrapper>
  )
}

const DropDown = (props: any) => {
  const {filterKey, filterValue, setFilterValue, options } = props
  return (
    <DropdownContainer>
      {options.map(({value, label}: any) => {
        return (
        <DropdownItem
          key = {`${filterKey}-${value}`}
          label = {label}
          value = {value}
          filterValue = {filterValue}
          setFilterValue = {setFilterValue}
        />
      )})}
    </DropdownContainer>
  )
}

export default DropDown